import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0c63fadc&scoped=true&"
import script from "./js/app.js?vue&type=script&lang=js&"
export * from "./js/app.js?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=0c63fadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c63fadc",
  null
  
)

export default component.exports